import EventLogsList from './event-logs-list';

export default EventLogsList;
